export const FETCH_ITEMS = 'FETCH_ITEMS'
export const FETCH_ITEMS_SUCCEED = 'FETCH_ITEMS_SUCCEEED'
export const FETCH_ITEMS_FAILURE = 'FETCH_ITEMS_FAILURE'
export const FETCH_ITEMS_CANCEL = 'FETCH_ITEMS_CANCEL'
export const TOGGLE_MYLIST_ITEM = 'TOGGLE_MYLIST_ITEM'
export const OPEN_ITEM_DETAIL = 'OPEN_ITEM_DETAIL'
export const CLOSE_ITEM_DETAIL = 'CLOSE_ITEM_DETAIL'
export const FETCH_FEATURE = 'FETCH_FEATURE'
export const FETCH_FEATURE_SUCCESS = 'FETCH_FEATURE_SUCCESS'
export const FETCH_FEATURE_FAILURE = 'FETCH_FEATURE_FAILURE'
export const FETCH_FEATURE_ITEMS = 'FETCH_FEATURE_ITEMS'
export const START_FETCH_FEATURE_ITEMS_PAGE = 'START_FEATURE_ITEMS_PAGE'
export const LOAD_NEXT_PAGE_FEATURE_ITEMS = 'LOAD_NEXT_PAGE_FEATURE_ITEMS'
export const WAIT_FETCH_FEATURE_ITEMS_PAGE = 'WAIT_FETCH_FEATURE_ITEMS_PAGE'
export const ABORT_WAIT_FETCH_FEATURE_ITEMS_PAGE = 'ABORT_WAIT_FETCH_FEATURE_ITEMS_PAGE'

export const MODAL_ENABLE_SCROLL = 'MODAL_ENABLE_SCROLL'

export const fetchItems = (query) => (
  {
    type: FETCH_ITEMS,
    query
  }
)

export const fetchItemsSucceed = (items, query, append = false) => (
  {
    type: FETCH_ITEMS_SUCCEED,
    items,
    query,
    append
  }
)

export const fetchItemsCancel = () => (
  {
    type: FETCH_ITEMS_CANCEL,
  }
)

export const toggleMylistItem = (id) => (
  {
    type: TOGGLE_MYLIST_ITEM,
    id
  }
)

export const openItemDetail = (item) => (
  {
    type: OPEN_ITEM_DETAIL,
    item
  }
)

export const closeItemDetail = (item) => (
  {
    type: CLOSE_ITEM_DETAIL,
  }
)

export const fetchFeature = (id, itemId, category) => (
  {
    type: FETCH_FEATURE,
    id,
    itemId,
    category
  }
)



// WEBPACK FOOTER //
// ./src/actions/index.js